<template>
    <div class="p-0">
    
    <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
        <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
            <CRow class="m-2">
                <CCol sm="12">
                    <h3 class="custom-40px-500 text-center mt-0">Contact Us</h3>  </CCol>
                <CCol sm="12">
<CRow>
    <CCol sm="10"><CInput type="text" placeholder="Search User" v-model="searchQuery" @keyup.enter="filterList"/></CCol>
    <CCol sm="2">
        <CSelect>
            <CSelect
                  label="Sort By"
                  :options="['Sort By',2,3,4,5,6,7,8,9,10,11,12]"
                />
        </CSelect>
    </CCol>

</CRow>
<template v-if="Busy == true">
                    <div class="container text-center">
                      <pulse-loader
                        :loading="loading"
                        :color="color"
                        :size="size"
                      ></pulse-loader>
                    </div>
                  </template>
                    <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                        <thead class="bg-f7f7f7 b-20">
                            <th> <label class="custom-12px-700">Date</label></th>
                            <th><label class="custom-12px-700">Name</label></th>
                            <th> <label class="custom-12px-700">Mobile Number</label></th>
                            <th><label class="custom-12px-700">Email</label></th>
                            <th><label class="custom-12px-700">Message</label></th>
                            <th><label class="custom-12px-700">Status</label></th>
                            <th><label class="custom-12px-700">Action</label></th>
                        </thead>

                        <tbody>
                            <tr v-for="item in filteredList" v-bind:key="item.videoId">
                              
                                <td>
                                    <label class="custom-12px-700">{{ item.CreatedDate | moment("DD-MM-YYYY") }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.Name }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.Phone }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.Email }}</label>
                                </td>
                                <td>
                                    <label class="custom-12px-700">{{ item.Help }}</label>
                                </td>
                                <td>
                                    <div class="badge-border-purple font-color-928AFD">
                                        Unsolve
                                    </div>
                                </td>
                                <td>
                                   
                    <CButton class="custom-border-purple text-white"><span class="ml-2 mr-2">Detail</span></CButton>
                    <img src="../assets/img/delete2.png" style="max-width:30px" class="ml-2">
                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                    <div class="text-center">
                   
                </div>
                </CCol>

            </CRow>

            <div v-if="isPopupVisible2" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width:100px" src="../assets/img/questionmark.png" />
                        <h3 class="custom-32px-500 font-color-171717">Are you sure?!</h3>
                        <h3 class="custom-16px-400 text-center">By subscribing, you will gain access to view these 25 candidates
                        </h3>
                        <br /><br />
                        <label class="custom-border-purple-white p-2 mr-5 font-color-928AFD" style="width:130px">Cancel</label>
                        <label class="custom-border-purple p-2 mr-5 text-white" style="width:130px">Yes</label>
                      
                    </div>
    
                </div>
            </div>

            <div v-if="isPopupVisible3" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closeVideoPopup" />
                    <iframe :src="videoUrl" frameborder="0" allowfullscreen style="width: 100%; height: 300px;"></iframe>

                </div>
            </div>
        </CCard>
<br /><br /><br />
    </CCol>

    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            list: [],
            user: {},
            isPopupVisible3: false,
        videoUrl: '',
        searchQuery: '',
        Busy: false

        };
    },
    async mounted() {
    try {
      const isAuth = await this.UserAuth();
      if (isAuth) {
        await this.GetInfoUser(); // Fetch the user details first
        this.GetListContactUs();
         
        } else {
        this.GoToLogin();
      }
    } catch (error) {
      console.error("Error during authentication:", error);
      // Handle the error here
    }
       
    },

    computed: {
        filteredList() {
  const query = this.searchQuery.toLowerCase().trim();
  
  return this.list.filter(item => {
    const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
    const hasRelevantSessionDetails = item.SessionDetails &&
      item.SessionDetails.length > 0
    return matchesQuery;
  });
}
  },
    methods: {
        async GetInfoUser() {
      try {
        const response = await this.$API.get(this.$LoginUserDetail, {
          withCredentials: true,
        });
        if (response.status === 200) {
          this.user = response.data;
          console.log("userInfo", this.user);
        } else {
          // Handle non-200 status code
          console.error("Failed to fetch user information:", response);
        }
      } catch (error) {
        console.error("Error fetching user information:", error);
        // Handle the error here
      }
    },
        async GetListContactUs() {
        try {
            this.Busy = true;
            const response = await this.$API.get(this.$GetListContactUs);
            if (response.status === 200) {
                this.Busy = false;
                this.list = response.data;
            } else {
                // Handle non-200 status code
            }
        } catch (error) {
            // Handle the error here
        }
    },
       
       
    }

};
</script>

